import React, { ReactNode } from 'react'
import BtnPrimary from 'components/generic/BtnPrimary'
import BtnSecondary from 'components/generic/BtnSecondary'
import Modal from 'react-modal'
import styles from './modalWTN.module.scss'
import { useModalState, useModalDispatch, BasicModalState } from 'hooks/use-modal'
import cx from 'classnames'

interface BtnObj {
  text: string
  onClick: () => void
}

export interface ModalWtnProps extends Omit<Modal.Props, 'isOpen'> {
  children: ReactNode
  textHeader?: string
  btnPrimary?: BtnObj
  btnSecondary?: BtnObj
  btnAlignment?: 'left' | 'right'
  widgetElId: string
  modalId: string
  className?: string
  reducedHeaderMargin?: boolean
}

const ModalWTN = ({
  children,
  textHeader,
  btnPrimary,
  btnSecondary,
  widgetElId,
  modalId,
  btnAlignment = 'left',
  className = '',
  reducedHeaderMargin = false,
  ...props
}: ModalWtnProps) => {
  const modalState: BasicModalState = useModalState(modalId as never)
  const { modalDispatch, modalActions } = useModalDispatch(modalId as never)
  return (
    <Modal
      {...props}
      isOpen={modalState?.isOpen}
      onRequestClose={() => modalDispatch(modalActions.closeModal())}
      closeTimeoutMS={500}
      className={cx(styles.modalWrapper, className)}
      portalClassName='modal-wtn-portal'
      appElement={document.getElementById(widgetElId) as HTMLElement}
    >
      {textHeader && (
        <h2 className={cx(styles.header, { [styles.reducedMargin]: reducedHeaderMargin })}>
          {textHeader}
        </h2>
      )}

      <div className={styles.body}>{children}</div>
      <div className={cx(styles.btns, styles[btnAlignment])}>
        {btnSecondary && (
          <BtnSecondary onClick={btnSecondary.onClick} size={'medium'} className={styles.button}>
            {btnSecondary.text}
          </BtnSecondary>
        )}
        {btnPrimary && (
          <BtnPrimary onClick={btnPrimary.onClick} size={'medium'} className={styles.button}>
            {btnPrimary.text}
          </BtnPrimary>
        )}
      </div>
    </Modal>
  )
}

export default ModalWTN
